var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from "@reduxjs/toolkit";
import indoorHelper from "../../store/helpers/indoorHelper";
var slice = createSlice({
    name: "overview",
    initialState: {
        defaultHrn: "",
        collectionHrnList: [],
        defaultSnapshotData: {},
        defaultSnapshotTime: 0,
        collectionTabList: [],
    },
    reducers: {
        setCollection: function (state, _a) {
            var payload = _a.payload;
            return __assign(__assign({}, state), { defaultHrn: payload[0], collectionHrnList: payload });
        },
        setDefaultSnapshotData: function (state, _a) {
            var payload = _a.payload;
            return __assign(__assign({}, state), { defaultSnapshotTime: indoorHelper.getTimeByDate(payload.snapshotTimes[0]), defaultSnapshotData: payload });
        },
        setCollectionTabList: function (state, _a) {
            var payload = _a.payload;
            return __assign(__assign({}, state), { collectionTabList: payload });
        },
    },
});
export var setCollection = (_a = slice.actions, _a.setCollection), setDefaultSnapshotData = _a.setDefaultSnapshotData, setCollectionTabList = _a.setCollectionTabList;
export default slice.reducer;
